import { render, staticRenderFns } from "./indexpage.vue?vue&type=template&id=316997ed&scoped=true&"
import script from "./indexpage.vue?vue&type=script&lang=js&"
export * from "./indexpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316997ed",
  null
  
)

export default component.exports